import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../actions/reportAction';
import * as orderAction from './../../../../../actions/orderAction';
import BundleReport from './BundleReport'
import * as bundleReportAction from './../../../../../actions/bundleReportAction'

const mapStateToProps = state => {
    return {
        bundleReportState: state.bundleReportReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        exportBundleExcel: filters => dispatch(bundleReportAction.exportBundleReportExcel(filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BundleReport));
